// "+ Agregar otro ingreso" para una persona de la ficha (titular, cónyuge o
// dependiente). La regla de cómo se guarda y qué suma vive en
// crm-app/otrosIngresos.js; esto es solo la pantalla.
//
// El ingreso de siempre, con su empleador y su tipo de empleo, sigue arriba
// como INGRESO PRINCIPAL. Aquí van los de más (Lissette 2026-10-27: "un solo
// cliente tiene dos tipos de ingresos diferentes, ya sea por cuenta ajena o
// dos trabajos"). En cuanto hay uno, se enseña el total de la persona.
import { TIPOS_DE_INGRESO, MAX_OTROS_INGRESOS, ingresoTotalDePersona, dineroLegible } from '../otrosIngresos.js';

export function OtrosIngresos({ principal, lista, onChange, lang }) {
  const es = lang === 'es';
  const filas = Array.isArray(lista) ? lista : [];
  const cambiar = (i, k, v) => onChange(filas.map((f, j) => (j === i ? { ...f, [k]: v } : f)));
  const quitar = (i) => onChange(filas.filter((_, j) => j !== i));
  const agregar = () => onChange([...filas, { empleador: '', tipo: '', monto: '' }]);
  const total = filas.length ? ingresoTotalDePersona(principal, filas) : null;

  return (
    <div style={{ margin: '.25rem 0 .7rem' }}>
      {filas.map((f, i) => (
        <div key={i} style={{ display: 'flex', flexWrap: 'wrap', gap: '.5rem', alignItems: 'flex-end', marginBottom: '.45rem' }}>
          <div style={{ flex: '2 1 180px', minWidth: 0 }}>
            <label className="dkt-input-lbl">{es ? `Otro ingreso ${i + 1} — fuente` : `Other income ${i + 1} — source`}</label>
            <input className="dkt-inp" value={f.empleador || ''} maxLength={120}
              onChange={(e) => cambiar(i, 'empleador', e.target.value)}
              placeholder={es ? 'Ej: Uber, segundo trabajo…' : 'E.g. Uber, second job…'} />
          </div>
          <div style={{ flex: '1 1 140px', minWidth: 0 }}>
            <label className="dkt-input-lbl">{es ? 'Tipo' : 'Type'}</label>
            <select className="dkt-inp" value={f.tipo || ''} onChange={(e) => cambiar(i, 'tipo', e.target.value)}>
              <option value="">-- {es ? 'Seleccionar' : 'Select'} --</option>
              {TIPOS_DE_INGRESO.map((t) => <option key={t.id} value={t.id}>{es ? t.es : t.en}</option>)}
            </select>
          </div>
          <div style={{ flex: '1 1 120px', minWidth: 0 }}>
            <label className="dkt-input-lbl">{es ? 'Monto anual' : 'Annual amount'}</label>
            <input className="dkt-inp" value={f.monto || ''} maxLength={40}
              onChange={(e) => cambiar(i, 'monto', e.target.value)} placeholder="$12,000" />
          </div>
          <button type="button" className="dkt-btn-g" onClick={() => quitar(i)}
            title={es ? 'Quitar este ingreso' : 'Remove this income'}
            aria-label={es ? 'Quitar este ingreso' : 'Remove this income'}
            style={{ padding: '.45rem .65rem' }}>✕</button>
        </div>
      ))}
      <div style={{ display: 'flex', alignItems: 'center', gap: '.75rem', flexWrap: 'wrap' }}>
        {filas.length < MAX_OTROS_INGRESOS && (
          <button type="button" className="dkt-btn-g" onClick={agregar} style={{ fontSize: '.78rem', padding: '.35rem .7rem' }}>
            + {es ? 'Agregar otro ingreso' : 'Add another income'}
          </button>
        )}
        {total !== null && (
          <span style={{ fontSize: '.8rem', color: 'var(--c-text2,#7aa3c0)' }}>
            {es ? 'Total de esta persona:' : 'This person’s total:'}{' '}
            <b style={{ color: 'var(--c-green,#00ff88)' }}>{dineroLegible(total)}</b>
          </span>
        )}
      </div>
    </div>
  );
}
